<div class="card-body">

  <form>

    <div class="row">

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">کاشناس مسئول</label>
        <select class="custom-select" [(ngModel)]="Selection_KarshnasMasol_Id" name="Selection_KarshnasMasol_Id">
          <option value="0">انتخاب کنید</option>
          <option *ngFor="let item of DataList_KarshnasMasol" [value]="item.id">
            <span *ngIf="item.sex==1">آقای</span>
            <span *ngIf="item.sex==0">خانم</span>
            {{item.fname}} {{item.lname}}
          </option>

        </select>
      </div>

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">نوع راه ارتباطی</label>
        <select class="custom-select" (change)="Read_Karshenash_Link()" [(ngModel)]="Selection_KarshnasMasol_Link"
          name="Selection_KarshnasMasol_Link">
          <option value="0">انتخاب کنید</option>
          <option value="1">شماره همراه</option>
          <option value="2">تلفن</option>
          <option value="3">ایمیل </option>
        </select>
      </div>

      <div class="form-group col-md-4">
        <label for="exampleInputEmail1">راه ارتباطی</label>
        <select class="custom-select" [(ngModel)]="Selection_KarshnasMasol_Link_Dsc"
          name="Selection_KarshnasMasol_Link_Dsc">
          <option value="">انتخاب کنید</option>
          <option *ngFor="let item of DataList_KarshnasMasol_link" [value]="item">{{item}}</option>

        </select>
      </div>

    </div>

    <div class="row">
      <div class="form-group col-md-12">
        <label for="exampleInputEmail1">خلاصه گفتگو</label>
        <textarea class="form-control" [(ngModel)]="Selection_Dsc" name="Selection_Dsc"
          placeholder="اینجا تایپ کنید ..."></textarea>
      </div>
    </div>

    <div class="row">
      <div class="form-group col-md-3">
        <label for="exampleInputEmail1">
          فایل/های ضمیمه
          <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
              class="fa  fa-times-rectangle"></i> </button>
        </label>
        <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
        <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
          class="form-control" placeholder="اینجا تایپ کنید ...">
      </div>
      <div class="form-group col-md-6">
        <button type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc" class="btn btn-info"
          style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن ضمیمه </button>
      </div>
    </div>

    <div class="table-responsive" *ngIf="file_uploaded_src.length>0">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #3e399b; color: white;">
          <tr>
            <th>#</th>
            <th>فایل</th>
            <th>امکانات</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let itemFile of file_uploaded_src">

            <td>{{file_uploaded_src.indexOf(itemFile)+1}}</td>
            <td>

              <a target="_blank" *ngIf="itemFile.includes('.pdf')" href="{{BaseURlFile}}File/Letter/{{itemFile}}"
                class="btn btn-success"><i class="fa fa-file-pdf-o"></i> PDF </a>


              <img *ngIf="!itemFile.includes('.pdf')" (click)="openModal(templateImage,itemFile)"
                style="width: 150px;cursor: zoom-in;" src="{{BaseURlFile}}File/Letter/{{itemFile}}" />
            </td>
            <td>
              <div class="btn-group  " role="group" aria-label="دکمه group with nested dropdown">
                <div class="btn-group" role="group">
                  <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    امکانات
                  </button>
                  <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                    <a style="cursor: pointer;"
                      (click)="UploadImageSrc_List_Delete(file_uploaded_src.indexOf(itemFile),item)"
                      class="dropdown-item"><i class="fa fa-remove"></i> حذف </a>
                  </div>
                </div>
              </div>
            </td>

          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <br />
    <br />

    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" (click)="OnSubmit()" type="button" class="btn btn-success"
      style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> ثبت اطلاعات </button>

    <button *ngIf="!InProccessing" (click)="Read_Karshenash_Masole()" type="button" class="btn btn-info"
      style="margin-left: 5px;"><i class="fa fa-refresh"></i> بروز رسانی</button>


  </form>



</div>

<ng-template #templateImageForm>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> فرم بارگذاری فایل </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_ImageForm.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group col-md-6">
      <label for="exampleInputEmail1">
        فایل/های ضمیمه
        <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
            class="fa  fa-times-rectangle"></i> </button>
      </label>
      <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
      <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
        class="form-control" placeholder="اینجا تایپ کنید ...">
    </div>
  </div>
  <div class="modal-footer">

    <button *ngIf="canEditMainForm" type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc"
      class="btn btn-info" style="margin-left: 5px;"><i class="fa  fa-plus-circle"></i> افزودن ضمیمه </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_ImageForm.hide()">بستن</button>
  </div>
</ng-template>

<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> نمایش عکس </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseURlFile}}File/Letter/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseURlFile}}File/Letter/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> دانلود </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">بستن</button>
  </div>
</ng-template>